export default __webpack_public_path__ + "static/media/middle-point.175d35b9.svg";